import React from 'react';

export default () => (
    <div className="view-header">
        <header className="title text-white">
            <h1 className="h4 text-uppercase">Workflow</h1>
            <p className="mb-0">Users permission management</p>
        </header>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/workflow/view-header.js